module.exports = __webpack_public_path__ + "img/7534e96.png";